import React from 'react'
import CodesTemplate from '../../components/templates/codes/CodesTemplate'

const Codes = () => {
    return (
        <CodesTemplate />
    )
}

export default Codes